import React from "react";

const Color: React.FC = () => {
    return (
        <div className="fixed inset-0 p-1 w-full h-full bg-gradient-to-t 
        from-bg-dark to-transparent opacity-40 pointer-events-none z-40"/>
    );
};

export default Color;
